function trendEvaluator(trend, score) {
  const ratio = trend / score;
  return ratio < 1 ? -1 : 1;
}

export default trendEvaluator;
